import { useAmbienceIfPresent } from "./ambience-player-provider";
import { claimAudioFocus } from "./audio-focus";

// Wire a primary player (reset video, narration) into the audio-focus bus:
// claims focus + ducks the ambience bed on play, restores it on stop.
export function usePrimaryAudio(owner: string, duckLevel = 0.05) {
  const ambience = useAmbienceIfPresent();
  return (playing: boolean) => {
    if (playing) {
      claimAudioFocus(owner);
      ambience?.duck(duckLevel, 300);
    } else {
      ambience?.unduck(500);
    }
  };
}
